<script lang="ts">
	import { ImagePlaceholder } from "flowbite-svelte-v1";
	import { twMerge, type ClassNameValue } from "tailwind-merge";
	import type { Point } from "#gen/bundles/v1/common_pb.js";
	import FocalImage from "#lib/components/FocalImage.svelte";
	import type { Snippet } from "svelte";

	interface Props {
		src?: string;
		height?: number;
		width?: number;
		alt?: string;
		priority?: boolean;
		lazy?: boolean;
		focalPoint?: Point;
		hideGradient?: boolean;
		class?: ClassNameValue;
		custom?: Snippet;
	}

	const { src = "", height = 0, width = 0, alt = "", priority = false, lazy = false, focalPoint, hideGradient = false, class: className, custom }: Props = $props();

	let invalid = $state(false);

	$effect(() => {
		if (src) {
			invalid = false;
		}
	});
</script>

{#snippet placeholder()}
	<ImagePlaceholder size="sm" imgOnly={true} class={twMerge("h-full w-full animate-none", className as string)} classes={{ image: "h-full sm:w-full w-full bg-gray-50 m-0", svg: "h-6 w-6 text-gray-400" }} />
{/snippet}

<div class={twMerge("relative h-full w-full", className)}>
	{#if src && !invalid}
		{#if custom}
			{@render custom()}
		{:else if height && width}
			<FocalImage {priority} {src} layout="fixed" fetchpriority={priority ? "high" : "low"} loading={lazy ? "lazy" : "eager"} {width} {height} {alt} {focalPoint} />
		{:else}
			<FocalImage {priority} {src} height={640} width={480} layout="constrained" fetchpriority={priority ? "high" : "low"} loading={lazy ? "lazy" : "eager"} {alt} style="height: 100%; max-height: 100%;" {focalPoint} />
		{/if}
	{:else}
		{@render placeholder()}
	{/if}
	{#if !hideGradient}
		<div class="absolute inset-0 bg-linear-to-b from-transparent from-40% to-gray-800 to-90% opacity-95"></div>
	{/if}
</div>
